window.addEventListener('load', function() {
 // Create a video element
    var videoElement = document.createElement('video');
    videoElement.setAttribute('controls', '');  // Add video controls (play, pause, volume)
    videoElement.setAttribute('width', '100%');  // Set video width (optional)
    videoElement.setAttribute('class', 'genievideo');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('loop', '');
    videoElement.setAttribute('controlsList', 'nodownload');

    var videoSource = document.createElement('source');
    videoSource.setAttribute('src', 'https://cdn.shopify.com/videos/c/o/v/639c4c5d5d8c42edba2846a024839c17.mp4#t=0.90'); // Replace with your video URL
    videoSource.setAttribute('type', 'video/mp4');  // Specify video type
    videoElement.appendChild(videoSource);

    var videoTrack = document.createElement('track');
    //videoTrack.setAttribute('src', 'https://cdn.shopify.com/videos/c/o/v/639c4c5d5d8c42edba2846a024839c17.mp4#t=0.90'); // Replace with your video URL
    videoTrack.setAttribute('srclang', 'en');
    videoTrack.setAttribute('kind', 'Captions');
    videoTrack.setAttribute('label', 'English');
    videoElement.appendChild(videoTrack);
  
    var videoContainer = document.getElementById('video-container');
    videoContainer.appendChild(videoElement);
});